import React from 'react';
import LoginBkg from '../../images/loginBkg.jpg';
import LoginBkgRetina from '../../images/loginBkg@2x.jpg'
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: stretch;
`;

const Column = styled.div`
  flex: 50%;
  min-width: 320px;
  height: 100vh;
`;

const ColumnWithBkg = styled.div`
  flex: 50%;
  align-self: stretch;
  background-image: url(${LoginBkg}); 
  background-position: top left;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  @media only screen and (min-width: 1921px) {
    background-image: url(${LoginBkgRetina}); 
  }
`;

export default ({ children }) => {
  return (
    <Container>
      <Column>{children}</Column>
      <ColumnWithBkg />
    </Container>
  );
}
